import Markdown from 'react-markdown';

const VARIANT_CLASSES = {
  tip: {
    container: 'bg-blue-50 border-blue-500',
    text: 'text-blue-900',
    label: 'Tip:'
  },
  info: {
    container: 'bg-blue-50 border-blue-500',
    text: 'text-blue-900',
    label: 'Info:'
  },
  warning: {
    container: 'bg-yellow-50 border-yellow-500',
    text: 'text-yellow-900',
    label: 'Pozor:'
  },
  success: {
    container: 'bg-green-50 border-green-500',
    text: 'text-green-900',
    label: 'Dobrá zpráva:'
  }
};

const GlossaryCallout = ({ calloutVariant: variant = 'tip', text }) => {
  if (!text) return null;

  const styles = VARIANT_CLASSES[variant] || VARIANT_CLASSES.tip;

  return (
    <aside
      className={`my-2 rounded-r-2xl border-l-[3px] px-5 py-4 text-[15px] leading-relaxed ${styles.container} ${styles.text}`}
    >
      <span className="font-bold">{styles.label}</span>{' '}
      <span className="[&_p]:m-0 [&_p]:inline [&_strong]:font-bold">
        <Markdown>{text}</Markdown>
      </span>
    </aside>
  );
};

export default GlossaryCallout;
